// removed by extract-text-webpack-plugin
module.exports = {"upcomingEvent":"src-components-header----UpcomingEvent-module---upcomingEvent---3KssN","link":"src-components-header----UpcomingEvent-module---link---2W3VN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header/UpcomingEvent.module.css
// module id = 646
// module chunks = 168707334958949